import axios from 'axios'

export const getAgentProfileRoute = agentId => `/api/rest/org/common/person/profilecard/${agentId}`

export async function getDxIqnData(hazelcastSessionId, tenantId, cancelToken) {
  const dxSession = await axios.post('/advancedreporting/api/v4/sessions', { hazelcastSessionId }, { cancelToken })
  const dxRequestConfig = {
    cancelToken,
    headers: {
      Accept: 'application/json',
      Authorization: `Bearer ${dxSession.data.access_token}`,
    },
  }
  const [infospace, account] = await Promise.all([
    axios.get('/advancedreporting/api/infospaces/v1/show', dxRequestConfig),
    axios.get(`/advancedreporting/api/accounts/show/?email=lba.${tenantId}@calabrio1.com`, dxRequestConfig),
  ])
  return { account, infospace }
}
export const getAgentProfile = async (agentId, cancelToken) => {
  const response = await axios.get(getAgentProfileRoute(agentId), { cancelToken })
  return response.data
}
